import { api, adminHeaders } from "@/lib/api";

const CHUNK = 4 * 1024 * 1024;

export const sampleFileUrl = (id) => `${process.env.REACT_APP_BACKEND_URL}/api/samples/${id}/file`;

export const uploadSample = async (productId, file, title, onProgress, folderId = "") => {
  const init = await api.post(
    "/admin/samples/upload/init",
    { product_id: productId, filename: file.name, content_type: file.type || "application/octet-stream", size: file.size, title, folder_id: folderId },
    adminHeaders()
  );
  const { upload_id } = init.data;
  for (let offset = 0; offset < file.size; offset += CHUNK) {
    const blob = file.slice(offset, Math.min(offset + CHUNK, file.size));
    await api.post(`/admin/samples/upload/${upload_id}/chunk`, blob, {
      headers: { ...adminHeaders().headers, "Content-Type": "application/octet-stream" },
    });
    onProgress?.(Math.min(offset + CHUNK, file.size) / file.size);
  }
  const done = await api.post(`/admin/samples/upload/${upload_id}/complete`, {}, adminHeaders());
  return done.data;
};
